import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { FeatureToggleDto } from '../model';

class FeatureToggleClient extends BaseClient {
  getFeatureToggles(): AxiosPromise<FeatureToggleDto[]> {
    return this.request({
      url: `${hosts.userApi}/feature_toggles/`,
      method: 'GET',
      params: { ordering: 'id' },
    });
  }
}

export const featureToggleClient = new FeatureToggleClient();
